/*
  JDG Leather Swatch Selector — Natuzzi
  Tiered by grade: 10 (base) | 15 (+$155) | 20 (+$265) | 25 (+$355)
  Images: Natuzzi Editions Coverings — June 2026
  v3 — Inline panel with grade tabs + left/right arrows + Select This Leather
*/
(function () {

  /* ── Swatch images: full variant title → Natuzzi supplier image ── */
  var SW = {
    /* GRADE 10 — DENVER (base) */
    "10B4 - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0B4.jpg",
    "10B5 - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0B5.jpg",
    "10B6 - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0B6.jpg",
    "10B7 - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0B7.jpg",
    "10BF - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BF.jpg",
    "10BH - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BH.jpg",
    "10BI - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BI.jpg",
    "10BK - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BK.jpg",
    "10BL - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BL.jpg",
    "10BR - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BR.jpg",
    "10BS - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BS.jpg",
    "10BT - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BT.jpg",
    "10BU - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BU.jpg",
    "10BY - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BY.jpg",
    "10BZ - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BZ.jpg",

    /* GRADE 15 — LE MANS */
    "1575 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/1575.jpg",
    "1576 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/1576.jpg",
    "1581 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/1581.jpg",
    "1582 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/1582.jpg",
    "1583 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/1583.jpg",
    "15C1 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15C1.jpg",
    "15C3 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15C3.jpg",
    "15C4 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15C4.jpg",
    "15C5 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15C5.jpg",
    "15C6 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15C6.jpg",
    "15CI - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15CI.jpg",
    "15CQ - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15CQ.jpg",
    "15CT - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15CT.jpg",
    "15CW - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15CW.jpg",
    "15CY - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15CY.jpg",
    "15D1 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D1.jpg",
    "15D2 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D2.jpg",
    "15D4 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D4.jpg",
    "15D5 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D5.jpg",
    "15D7 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D7.jpg",
    "15D8 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D8.jpg",
    "15F1 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F1.jpg",
    "15F2 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F2.jpg",
    "15F3 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F3.jpg",
    "15F5 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F5.jpg",
    "15F8 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F8.jpg",
    "15F9 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F9.jpg",
    "15Y1 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15Y1.jpg",

    /* GRADE 15 — ARIZONA */
    "15B1 - ARIZONA": "https://newsuppliers.natuzzi.com/CreditCard/15B1.jpg",
    "15B2 - ARIZONA": "https://newsuppliers.natuzzi.com/CreditCard/15B2.jpg",
    "15B3 - ARIZONA": "https://newsuppliers.natuzzi.com/CreditCard/15B3.jpg",

    /* GRADE 15 — OREGON */
    "15WB - OREGON": "https://newsuppliers.natuzzi.com/CreditCard/15WB.jpg",
    "15WE - OREGON": "https://newsuppliers.natuzzi.com/CreditCard/15WE.jpg",
    "15WI - OREGON": "https://newsuppliers.natuzzi.com/CreditCard/15WI.jpg",
    "15WL - OREGON": "https://newsuppliers.natuzzi.com/CreditCard/15WL.jpg",
    "15WQ - OREGON": "https://newsuppliers.natuzzi.com/CreditCard/15WQ.jpg",
    "15OA - YELLOWSTONE": "https://newsuppliers.natuzzi.com/CreditCard/15OA.jpg",
    "15OB - YELLOWSTONE": "https://newsuppliers.natuzzi.com/CreditCard/15OB.jpg",
    "15OD - YELLOWSTONE": "https://newsuppliers.natuzzi.com/CreditCard/15OD.jpg",
    "15OE - YELLOWSTONE": "https://newsuppliers.natuzzi.com/CreditCard/15OE.jpg",

    /* GRADE 20 — DREAM */
    "20J1 - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20J1.jpg",
    "20J2 - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20J2.jpg",
    "20J3 - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20J3.jpg",
    "20J4 - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20J4.jpg",
    "20J5 - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20J5.jpg",
    "20JE - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JE.jpg",
    "20JF - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JF.jpg",
    "20JG - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JG.jpg",
    "20JH - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JH.jpg",
    "20JI - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JI.jpg",
    "20JJ - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JJ.jpg",
    "20JK - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JK.jpg",
    "20JL - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JL.jpg",
    "20JQ - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JQ.jpg",
    "20JR - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JR.jpg",
    "20JV - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JV.jpg",
    "20JX - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JX.jpg",

    /* GRADE 20 — MADISON */
    "20RA - MADISON": "https://newsuppliers.natuzzi.com/CreditCard/20RA.jpg",
    "20RB - MADISON": "https://newsuppliers.natuzzi.com/CreditCard/20RB.jpg",
    "20RE - MADISON": "https://newsuppliers.natuzzi.com/CreditCard/20RE.jpg",

    /* GRADE 25 — LEISURE */
    "25VA - LEISURE": "https://newsuppliers.natuzzi.com/CreditCard/25VA.jpg",
    "25VE - LEISURE": "https://newsuppliers.natuzzi.com/CreditCard/25VE.jpg",
    "25VI - LEISURE": "https://newsuppliers.natuzzi.com/CreditCard/25VI.jpg",
    "25VL - LEISURE": "https://newsuppliers.natuzzi.com/CreditCard/25VL.jpg",
    "25VM - LEISURE": "https://newsuppliers.natuzzi.com/CreditCard/25VM.jpg",

    /* GRADE 25 — SONORA */
    "25YA - SONORA": "https://newsuppliers.natuzzi.com/CreditCard/25YA.jpg",
    "25YB - SONORA": "https://newsuppliers.natuzzi.com/CreditCard/25YB.jpg",
    "25YC - SONORA": "https://newsuppliers.natuzzi.com/CreditCard/25YC.jpg",
    "25YD - SONORA": "https://newsuppliers.natuzzi.com/CreditCard/25YD.jpg"
  };

  /* ── Tier config ── */
  var TIERS = [
    { grade: '10', label: 'Grade 10', upcharge: '',      upchargeLabel: 'Included',  test: function(c){ return /^10/.test(c); } },
    { grade: '15', label: 'Grade 15', upcharge: '+$155', upchargeLabel: '+$155',     test: function(c){ return /^15/.test(c); } },
    { grade: '20', label: 'Grade 20', upcharge: '+$265', upchargeLabel: '+$265',     test: function(c){ return /^20/.test(c); } },
    { grade: '25', label: 'Grade 25', upcharge: '+$355', upchargeLabel: '+$355',     test: function(c){ return /^25/.test(c); } }
  ];

  function getTier(variantTitle) {
    var code = variantTitle.split(' - ')[0] || '';
    for (var i = 0; i < TIERS.length; i++) {
      if (TIERS[i].test(code)) return TIERS[i];
    }
    return TIERS[0];
  }

  /* ── Family descriptions ── */
  var FAM = {
    'DENVER':      { label: 'Denver Full-Grain',    desc: 'Semi-aniline full-grain leather. Soft hand-feel with natural grain. Ages beautifully.' },
    'LE MANS':     { label: 'Le Mans Corrected',    desc: 'Corrected-grain leather with a uniform, elegant finish. Highly durable.' },
    'ARIZONA':     { label: 'Arizona Waxed',        desc: 'Pull-up waxed leather. Develops a rich patina over time.' },
    'OREGON':      { label: 'Oregon Split-Grain',   desc: 'Contemporary matte split-grain leather. Smooth modern feel.' },
    'YELLOWSTONE': { label: 'Yellowstone Nubuck',   desc: 'Soft nubuck-finish leather with a velvety texture. Luxuriously tactile.' },
    'DREAM':       { label: 'Dream Protected',      desc: 'Protected full-grain leather. Excellent durability and easy to clean.' },
    'MADISON':     { label: 'Madison Waxed',        desc: 'Classic waxed pull-up leather with a vintage character.' },
    'LEISURE':     { label: 'Leisure Aniline',      desc: 'Pure aniline leather. The softest, most natural feel available.' },
    'SONORA':      { label: 'Sonora Aniline',       desc: 'Full aniline leather with exceptional softness and breathability.' }
  };

  /* ── CSS ── */
  var s = document.createElement('style');
  s.textContent = [
    /* Swatch grid tiles */
    '.jdg-sw-tier{margin-bottom:14px}',
    '.jdg-sw-tier-hdr{display:flex;align-items:center;justify-content:space-between;padding:5px 10px;background:#f5f2ee;border-radius:6px;margin-bottom:7px}',
    '.jdg-sw-tier-hdr.g10{background:#FDF6E3;border:1px solid #E8C97A}',
    '.jdg-sw-tier-name{font-size:11px;font-weight:700;color:#333;text-transform:uppercase;letter-spacing:.06em}',
    '.jdg-sw-tier-price{font-size:11px;font-weight:700;color:#555}',
    '.jdg-sw-tier-hdr.g10 .jdg-sw-tier-price{color:#8B6914}',
    '.jdg-sw-grid{display:flex;flex-wrap:wrap;gap:7px}',
    '.jdg-sw-tile{width:52px;height:52px;flex-shrink:0;position:relative;border:2px solid #D4CCC3;border-radius:6px;overflow:hidden;cursor:pointer;background:#f5f0ea;transition:border-color .15s,transform .15s}',
    '.jdg-sw-tile:hover{border-color:#8A7F75;transform:scale(1.08);z-index:5}',
    '.jdg-sw-tile.on{border-color:#1c1c1c;box-shadow:0 0 0 2px #1c1c1c}',
    '.jdg-sw-tile img{width:100%;height:100%;object-fit:cover;display:block;pointer-events:none}',
    '.jdg-sw-tile.on::after{content:"✓";position:absolute;top:2px;right:3px;width:14px;height:14px;background:#1c1c1c;color:#fff;font-size:9px;border-radius:50%;display:flex;align-items:center;justify-content:center;line-height:14px;text-align:center;font-weight:bold}',

    /* ── Inline panel ── */
    '.jdg-lp-panel{margin-top:18px;border:1px solid #e0d8d0;border-radius:10px;overflow:hidden;background:#fff;box-shadow:0 4px 20px rgba(0,0,0,.10)}',

    /* Grade tab bar */
    '.jdg-lp-tabs{display:flex;border-bottom:1px solid #e0d8d0;background:#f9f6f2}',
    '.jdg-lp-tab{flex:1;padding:9px 4px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:#888;border:none;background:none;cursor:pointer;border-bottom:2px solid transparent;transition:color .15s,border-color .15s;font-family:inherit}',
    '.jdg-lp-tab:hover{color:#555}',
    '.jdg-lp-tab.active{color:#1c1c1c;border-bottom-color:#1c1c1c}',
    '.jdg-lp-tab-price{display:block;font-size:9px;font-weight:500;color:#B89A6A;letter-spacing:.04em;margin-top:1px}',
    '.jdg-lp-tab.active .jdg-lp-tab-price{color:#8B6914}',

    /* Panel body */
    '.jdg-lp-body{display:flex;gap:0;min-height:220px}',

    /* Left: big leather image */
    '.jdg-lp-img-wrap{flex-shrink:0;width:200px;background:#f5f0ea;position:relative;overflow:hidden}',
    '@media(max-width:480px){.jdg-lp-img-wrap{width:130px}}',
    '.jdg-lp-img-wrap img{width:100%;height:100%;object-fit:cover;display:block;transition:opacity .2s}',
    '.jdg-lp-img-wrap img.fading{opacity:0}',

    /* Arrows over image */
    '.jdg-lp-arrow{position:absolute;top:50%;transform:translateY(-50%);width:32px;height:32px;background:rgba(255,255,255,.85);border:none;border-radius:50%;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.18);z-index:10;transition:background .15s;padding:0}',
    '.jdg-lp-arrow:hover{background:#fff}',
    '.jdg-lp-arrow.prev{left:8px}',
    '.jdg-lp-arrow.next{right:8px}',
    '.jdg-lp-arrow:disabled{opacity:.3;cursor:default}',

    /* Counter badge */
    '.jdg-lp-counter{position:absolute;bottom:8px;right:8px;background:rgba(28,28,28,.6);color:#fff;font-size:10px;padding:2px 7px;border-radius:10px;letter-spacing:.04em}',

    /* Right: details */
    '.jdg-lp-info{flex:1;padding:16px 16px 14px;display:flex;flex-direction:column;gap:4px;min-width:0}',
    '.jdg-lp-code{font-size:20px;font-weight:700;color:#1c1c1c;letter-spacing:.06em}',
    '.jdg-lp-grade-badge{display:inline-block;font-size:9px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#8B6914;background:#FDF6E3;border:1px solid #E8C97A;padding:2px 8px;border-radius:10px;margin-bottom:2px}',
    '.jdg-lp-fam{font-size:11px;letter-spacing:.15em;text-transform:uppercase;color:#B89A6A;font-weight:600}',
    '.jdg-lp-desc{font-size:12px;color:#6B6560;line-height:1.6;margin-top:4px;flex:1}',
    '.jdg-lp-badge{font-size:10px;color:#8A7F75;letter-spacing:.06em;border-top:1px solid #ece7e0;padding-top:8px;margin-top:4px}',

    /* Select button */
    '.jdg-lp-select-btn{width:100%;margin-top:10px;padding:11px 14px;background:#1c1c1c;color:#fff;border:none;border-radius:6px;font-size:12px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;transition:background .15s;font-family:inherit}',
    '.jdg-lp-select-btn:hover{background:#3a3a3a}',
    '.jdg-lp-select-btn.confirmed{background:#4a7c59}',

    /* Special order note */
    '.jdg-lp-special{font-size:10px;color:#8A7F75;text-align:center;margin-top:6px;letter-spacing:.04em}'
  ].join('');
  document.head.appendChild(s);

  /* ── Main init ── */
  function init() {
    if (document.querySelector('[data-img-sw]')) return;

    document.querySelectorAll('.jdg-pp-opt-group').forEach(function(group) {
      var lbl = group.querySelector('.jdg-pp-opt-lbl');
      if (!lbl) return;
      var optName = lbl.textContent.replace(/:.*/, '').trim();
      if (optName !== 'Leather') return;

      var btnRow = group.querySelector('.jdg-pp-opt-row');
      if (!btnRow || btnRow.dataset.sw) return;
      btnRow.dataset.sw = '1';

      var btns = Array.from(btnRow.querySelectorAll('.jdg-pp-ob'));
      if (!btns.length) return;

      /* Group all variants by tier grade */
      var tierMap = { '10': [], '15': [], '20': [], '25': [] };
      btns.forEach(function(btn) {
        var val  = btn.dataset.v;
        var tier = getTier(val);
        if (tierMap[tier.grade]) tierMap[tier.grade].push({ btn: btn, val: val });
      });

      /* Build swatch tiles wrap (hidden native buttons replaced) */
      var wrap = document.createElement('div');
      wrap.className = 'jdg-sw-wrap';

      /* ── Build inline panel ── */
      var panel = document.createElement('div');
      panel.className = 'jdg-lp-panel';
      panel.style.display = 'none';

      /* Tab bar */
      var tabBar = document.createElement('div');
      tabBar.className = 'jdg-lp-tabs';

      TIERS.forEach(function(tier) {
        if (!tierMap[tier.grade] || !tierMap[tier.grade].length) return;
        var tab = document.createElement('button');
        tab.className = 'jdg-lp-tab';
        tab.dataset.grade = tier.grade;
        tab.innerHTML =
          tier.label +
          '<span class="jdg-lp-tab-price">' + (tier.upcharge || 'Included') + '</span>';
        tabBar.appendChild(tab);
      });
      panel.appendChild(tabBar);

      /* Panel body */
      var body = document.createElement('div');
      body.className = 'jdg-lp-body';

      /* Image side */
      var imgWrap = document.createElement('div');
      imgWrap.className = 'jdg-lp-img-wrap';
      var mainImg = document.createElement('img');
      mainImg.src = ''; mainImg.alt = '';
      imgWrap.appendChild(mainImg);

      var prevBtn = document.createElement('button');
      prevBtn.className = 'jdg-lp-arrow prev';
      prevBtn.innerHTML = '&#8249;';
      prevBtn.title = 'Previous';
      imgWrap.appendChild(prevBtn);

      var nextBtn = document.createElement('button');
      nextBtn.className = 'jdg-lp-arrow next';
      nextBtn.innerHTML = '&#8250;';
      nextBtn.title = 'Next';
      imgWrap.appendChild(nextBtn);

      var counter = document.createElement('div');
      counter.className = 'jdg-lp-counter';
      imgWrap.appendChild(counter);

      body.appendChild(imgWrap);

      /* Info side */
      var info = document.createElement('div');
      info.className = 'jdg-lp-info';

      var codeEl   = document.createElement('div'); codeEl.className = 'jdg-lp-code';
      var gradeEl  = document.createElement('div'); gradeEl.className = 'jdg-lp-grade-badge';
      var famEl    = document.createElement('div'); famEl.className = 'jdg-lp-fam';
      var descEl   = document.createElement('div'); descEl.className = 'jdg-lp-desc';
      var badgeEl  = document.createElement('div');
      badgeEl.className = 'jdg-lp-badge';
      badgeEl.innerHTML = '🇮🇹 Exclusive Natuzzi Italian Leather';

      var selectBtn = document.createElement('button');
      selectBtn.className = 'jdg-lp-select-btn';
      selectBtn.textContent = 'Select This Leather';

      var specialNote = document.createElement('div');
      specialNote.className = 'jdg-lp-special';
      specialNote.textContent = '✦ Special Order — Made to Order in Your Choice of Leather';

      info.appendChild(codeEl);
      info.appendChild(gradeEl);
      info.appendChild(famEl);
      info.appendChild(descEl);
      info.appendChild(badgeEl);
      info.appendChild(selectBtn);
      info.appendChild(specialNote);
      body.appendChild(info);
      panel.appendChild(body);

      /* ── Panel state ── */
      var panelState = {
        activeGrade: null,   // grade string currently shown
        activeIndex: 0,      // index within that grade's list
        pendingVal:  null    // val highlighted in panel but not yet "selected"
      };

      function getGradeList(grade) {
        return tierMap[grade] || [];
      }

      function switchGrade(grade, index) {
        panelState.activeGrade = grade;
        panelState.activeIndex = index || 0;

        /* Update tabs */
        tabBar.querySelectorAll('.jdg-lp-tab').forEach(function(t) {
          t.classList.toggle('active', t.dataset.grade === grade);
        });

        renderPanelItem();
      }

      function renderPanelItem() {
        var grade = panelState.activeGrade;
        var idx   = panelState.activeIndex;
        var list  = getGradeList(grade);
        if (!list.length) return;

        /* Clamp */
        idx = Math.max(0, Math.min(idx, list.length - 1));
        panelState.activeIndex = idx;

        var item  = list[idx];
        var val   = item.val;
        var url   = SW[val] || '';
        var parts = val.split(' - ');
        var code  = parts[0] || val;
        var fam   = parts[1] || '';
        var tier  = getTier(val);
        var famInfo = FAM[fam] || { label: fam, desc: '' };

        panelState.pendingVal = val;

        /* Image fade */
        mainImg.classList.add('fading');
        setTimeout(function() {
          mainImg.src = url;
          mainImg.alt = val;
          mainImg.classList.remove('fading');
        }, 150);

        codeEl.textContent  = code;
        gradeEl.textContent = tier.label + (tier.upcharge ? '  ' + tier.upchargeLabel : '  Included');
        famEl.textContent   = famInfo.label;
        descEl.textContent  = famInfo.desc;

        counter.textContent = (idx + 1) + ' / ' + list.length;
        prevBtn.disabled = (idx === 0);
        nextBtn.disabled = (idx === list.length - 1);

        /* Reset select button */
        selectBtn.textContent = 'Select This Leather';
        selectBtn.classList.remove('confirmed');

        /* Highlight matching swatch tile */
        wrap.querySelectorAll('.jdg-sw-tile').forEach(function(t) {
          t.classList.toggle('on', t.dataset.swval === val);
        });
      }

      /* Arrow clicks */
      prevBtn.addEventListener('click', function() {
        panelState.activeIndex--;
        renderPanelItem();
      });
      nextBtn.addEventListener('click', function() {
        panelState.activeIndex++;
        renderPanelItem();
      });

      /* Tab clicks */
      tabBar.querySelectorAll('.jdg-lp-tab').forEach(function(tab) {
        tab.addEventListener('click', function() {
          switchGrade(tab.dataset.grade, 0);
        });
      });

      /* Select This Leather button */
      selectBtn.addEventListener('click', function() {
        var val = panelState.pendingVal;
        if (!val) return;

        /* Find and click the native hidden button */
        var match = null;
        btns.forEach(function(btn) { if (btn.dataset.v === val) match = btn; });
        if (match) match.click();

        /* Update label */
        var sp = lbl.querySelector('span');
        if (sp) {
          var t = getTier(val);
          sp.textContent = val + (t.upcharge ? '  (' + t.upchargeLabel + ')' : '');
        }

        /* Confirm animation */
        selectBtn.textContent = '✓ Leather Selected';
        selectBtn.classList.add('confirmed');
        setTimeout(function() {
          selectBtn.textContent = 'Select This Leather';
          selectBtn.classList.remove('confirmed');
        }, 2500);

        /* Highlight swatch */
        wrap.querySelectorAll('.jdg-sw-tile').forEach(function(t) {
          t.classList.toggle('on', t.dataset.swval === val);
        });
      });

      /* ── Render swatch grid tiers ── */
      ['10','15','20','25'].forEach(function(grade) {
        var list = tierMap[grade];
        if (!list || !list.length) return;

        var tier = getTier(list[0].val);

        var section = document.createElement('div');
        section.className = 'jdg-sw-tier';

        var hdr = document.createElement('div');
        hdr.className = 'jdg-sw-tier-hdr' + (grade === '10' ? ' g10' : '');

        var nameSpan = document.createElement('span');
        nameSpan.className = 'jdg-sw-tier-name';
        nameSpan.textContent = tier.label;

        var priceSpan = document.createElement('span');
        priceSpan.className = 'jdg-sw-tier-price';
        priceSpan.textContent = tier.upcharge || 'Included';

        hdr.appendChild(nameSpan);
        hdr.appendChild(priceSpan);
        section.appendChild(hdr);

        var grid = document.createElement('div');
        grid.className = 'jdg-sw-grid';

        list.forEach(function(item, idx) {
          var val = item.val;
          var url = SW[val];

          var tile = document.createElement('div');
          tile.className = 'jdg-sw-tile';
          tile.dataset.swval = val;
          tile.title = val;

          if (url) {
            var img = document.createElement('img');
            img.src = url; img.alt = val; img.loading = 'lazy';
            tile.appendChild(img);
          }

          /* Click → open panel on this grade + item */
          tile.addEventListener('click', function() {
            panel.style.display = '';
            switchGrade(grade, idx);

            /* Scroll panel into view smoothly */
            setTimeout(function() {
              panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 80);
          });

          /* Sync tile highlight from native button state */
          new MutationObserver(function() {
            tile.classList.toggle('on', item.btn.classList.contains('on'));
          }).observe(item.btn, { attributes: true, attributeFilter: ['class'] });

          /* If native button already selected, show it */
          if (item.btn.classList.contains('on')) tile.classList.add('on');

          grid.appendChild(tile);
        });

        section.appendChild(grid);
        wrap.appendChild(section);
      });

      /* Append panel after wrap */
      wrap.appendChild(panel);

      /* Hide native buttons, insert swatch sections */
      btnRow.style.cssText = 'display:none!important';
      btnRow.parentNode.insertBefore(wrap, btnRow.nextSibling);
    });

    /* ── Special Order: override "Out of Stock" ── */
    overrideOutOfStock();
  }

  /* Override any "Out of Stock" button text for Natuzzi special order products */
  function overrideOutOfStock() {
    function patchBtn() {
      var atcBtn = document.querySelector('.jdg-pp-atc, [name="add"], .product-form__submit, button[type="submit"]');
      if (!atcBtn) return;
      var txt = atcBtn.textContent.trim().toLowerCase();
      if (txt === 'out of stock' || txt === 'sold out' || txt === 'unavailable') {
        atcBtn.textContent = 'Add to Cart — Special Order';
        atcBtn.disabled = false;
        atcBtn.style.background = '';
        atcBtn.style.opacity = '';
        atcBtn.style.cursor = 'pointer';
      }
    }
    patchBtn();
    /* Also watch for Shopify updating button state after variant selection */
    var observer = new MutationObserver(patchBtn);
    var form = document.querySelector('form[action="/cart/add"]');
    if (form) observer.observe(form, { childList: true, subtree: true, attributes: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(init, 150); });
  } else {
    setTimeout(init, 150);
  }

})();